import _round from "lodash/round";
import { formatRoundValue } from "./formatNumber";
import { calculateCbmByDimension } from "../schema/items/productSchema";

export const calculateProductItemSummary = (currentRow) => {

    let _currentRow = currentRow

    let unitPrice = parseFloat(_currentRow?.uomPrice)
    let handleQty = parseFloat(_currentRow?.handleQty)
    let qty = parseFloat(_currentRow?.qty)
    // net_weight is stored at 4dp, so derive the total from that same value -- otherwise the
    // total reflects a precision the saved weight no longer carries and stops tallying with it.
    let weight = formatRoundValue(parseFloat(_currentRow?.weight), 4)

    let width = parseFloat(_currentRow?.width)
    let height = parseFloat(_currentRow?.height)
    let length = parseFloat(_currentRow?.length)

    let value = unitPrice * handleQty

    let totalValue = parseFloat(value)

    // console.log('unitPrice', unitPrice)
    // console.log('handleQty', handleQty)
    // console.log('qty', qty)
    // console.log('weight', weight)

    let cbm = calculateCbmByDimension({ w: width, h: height, l: length })

    // // // console.log('total:: ', totalValue, cbm)

    let totalCbm = cbm * qty
    let totalWeight = weight * qty

    if (Number.isNaN(totalValue)) totalValue = 0
    if (Number.isNaN(totalCbm)) totalCbm = 0
    if (Number.isNaN(totalWeight)) totalWeight = 0
    if (Number.isNaN(totalCbm)) totalCbm = 0

    _currentRow.summaryCbm = formatRoundValue(parseFloat(cbm), 4).toFixed(4)
    _currentRow.summaryTotalValue = formatRoundValue(parseFloat(totalValue), 2).toFixed(2)
    _currentRow.summaryTotalCbm = formatRoundValue(parseFloat(totalCbm), 4).toFixed(4)
    _currentRow.summaryTotalWeight = formatRoundValue(parseFloat(totalWeight), 4).toFixed(4)

    return _currentRow
}

export const calculateProductItemsSummary = (productItems) => {

    let summaryTotalPackQty = 0
    let summaryTotalWeight = 0
    let summaryTotalCbm = 0
    let summaryTotalValue = 0

    let a = []

    productItems.forEach((i4, index4) => {

        // let summary = productItems[index4]

        let unitPrice = parseFloat(i4?.uomPrice)
        let handleQty = parseFloat(i4?.handleQty)
        let qty = parseFloat(i4?.qty)
        let weight = formatRoundValue(parseFloat(i4?.weight), 4)

        let width = parseFloat(i4?.width)
        let height = parseFloat(i4?.height)
        let length = parseFloat(i4?.length)

        let value = unitPrice * handleQty

        let cbm = calculateCbmByDimension({ w: width, h: height, l: length })

        let totalValue = parseFloat(value)
        let totalCbm = cbm * qty
        let totalWeight = weight * qty

        // console.log('totalCbm', totalCbm, 'cbm', cbm, 'unitPrice', unitPrice, 'handleQty', handleQty, 'qty', qty, 'weight', weight, 'w:', width, 'l', length, 'h', height)

        let _cbm = parseFloat(cbm)
        let _totalWeight = parseFloat(totalWeight)
        let _totalValue = parseFloat(totalValue)
        let _totalCbm = parseFloat(totalCbm)
        let _totalQty = parseFloat(qty)

        // console.log('_totalCbm', _totalCbm)

        summaryTotalWeight += _totalWeight
        summaryTotalCbm += parseFloat(_totalCbm)
        summaryTotalValue += _totalValue
        summaryTotalPackQty += _totalQty

        a.push({
            ...i4,
            cbm: formatRoundValue(_cbm, 4).toFixed(4),
            totalCbm: formatRoundValue(_totalCbm, 4).toFixed(4),
            totalWeight: formatRoundValue(_totalWeight, 4).toFixed(4),
            totalValue: formatRoundValue(_totalValue, 2).toFixed(2)
        })

    })

    // console.log('______', summaryTotalCbm)

    let totalSummary = {
        qty: summaryTotalPackQty.toFixed(0),
        weight: summaryTotalWeight.toFixed(4),
        cbm: summaryTotalCbm.toFixed(4),
        value: summaryTotalValue.toFixed(2),
    }

    // console.log('totalSummary >>', totalSummary, totalCbm)

    return {
        items: a,
        totalSummary
    }
}
